export function getPrimeNgTranslations(dictionary: Record<string, string>) {
    const prime: Record<string, string> = {};

    Object.keys(dictionary).forEach((key: string): void => {
        const newKey: string = key.replace('primeng.', '');
        prime[newKey] = dictionary[key];
    });
    return {
        today: prime['today'],
        prevWeek: prime['prevWeek'],
        currentWeek: prime['currentWeek'],
        prevMonth: prime['prevMonth'],
        currentMonth: prime['currentMonth'],
        from: prime['from'],
        to: prime['to'],
        clear: prime['clear'],
        dayNames: [
            prime['dayNames.0'],
            prime['dayNames.1'],
            prime['dayNames.2'],
            prime['dayNames.3'],
            prime['dayNames.4'],
            prime['dayNames.5'],
            prime['dayNames.6'],
        ],
        dayNamesMin: [
            prime['dayNamesMin.0'],
            prime['dayNamesMin.1'],
            prime['dayNamesMin.2'],
            prime['dayNamesMin.3'],
            prime['dayNamesMin.4'],
            prime['dayNamesMin.5'],
            prime['dayNamesMin.6'],
        ],
        dayNamesShort: [
            prime['dayNamesShort.0'],
            prime['dayNamesShort.1'],
            prime['dayNamesShort.2'],
            prime['dayNamesShort.3'],
            prime['dayNamesShort.4'],
            prime['dayNamesShort.5'],
            prime['dayNamesShort.6'],
        ],
        monthNames: [
            prime['monthNames.0'],
            prime['monthNames.1'],
            prime['monthNames.2'],
            prime['monthNames.3'],
            prime['monthNames.4'],
            prime['monthNames.5'],
            prime['monthNames.6'],
            prime['monthNames.7'],
            prime['monthNames.8'],
            prime['monthNames.9'],
            prime['monthNames.10'],
            prime['monthNames.11'],
        ],
        monthNamesShort: [
            prime['monthNamesShort.0'],
            prime['monthNamesShort.1'],
            prime['monthNamesShort.2'],
            prime['monthNamesShort.3'],
            prime['monthNamesShort.4'],
            prime['monthNamesShort.5'],
            prime['monthNamesShort.6'],
            prime['monthNamesShort.7'],
            prime['monthNamesShort.8'],
            prime['monthNamesShort.9'],
            prime['monthNamesShort.10'],
            prime['monthNamesShort.11'],
        ],
    };
}
